<div class="row-search" data-export-ignore>
  <sd-6-17-1-input
    [placeholder]="'dashboard.search.placeholder' | transloco"
    [value]="rowSearchText()"
    (sd-input)="onRowSearch($event)">
    @if (rowSearchText()) {
      <button type="button" slot="right" class="clear-button" [attr.aria-label]="'dashboard.search.clear' | transloco" (click)="clearRowSearch()">
        <sd-6-17-1-icon library="{{ iconLibrary }}" name="system/close-circle"></sd-6-17-1-icon>
      </button>
    } @else {
      <sd-6-17-1-icon library="{{ iconLibrary }}" name="system/magnifying-glass" slot="right"></sd-6-17-1-icon>
    }
  </sd-6-17-1-input>
  @if (columns().length > 0) {
  <div class="column-select">
    <sd-6-17-1-dropdown distance="4" placement="bottom-end" rounded>
      <sd-6-17-1-button variant="secondary" slot="trigger" [attr.aria-label]="'dashboard.columnSelect.trigger' | transloco">
        <sd-6-17-1-icon library="{{ iconLibrary }}" name="system/eye-open"></sd-6-17-1-icon>
      </sd-6-17-1-button>
      <div class="column-select-panel">
        <sd-6-17-1-input
          size="md"
          [placeholder]="'dashboard.columnSelect.searchPlaceholder' | transloco"
          [value]="search()"
          (sd-input)="onSearch($event)">
          <sd-6-17-1-icon library="{{ iconLibrary }}" name="system/magnifying-glass" slot="right"></sd-6-17-1-icon>
        </sd-6-17-1-input>
        <div class="column-select-list">
          @for (col of filteredColumns(); track col.index) {
            <sd-6-17-1-checkbox
              size="md"
              [attr.checked]="hidden().has(col.label) ? null : ''"
              (sd-change)="toggle(col.label, $any($event.target).checked)">
              {{ col.label }}
            </sd-6-17-1-checkbox>
          }
        </div>
      </div>
    </sd-6-17-1-dropdown>
  </div>
  }
</div>
@if (noResults()) {
  <div class="no-results">
    <sd-6-17-1-icon library="{{ iconLibrary }}" name="warning"></sd-6-17-1-icon>
    <h3>{{ 'dashboard.search.noResults.title' | transloco }}</h3>
    <p>{{ 'dashboard.search.noResults.text' | transloco }}</p>
    <sd-6-17-1-button variant="secondary" (click)="resetSearchAndFilters()">
      {{ 'dashboard.search.noResults.reset' | transloco }}
    </sd-6-17-1-button>
  </div>
} @else {
<table class="sd-table">
  @for (curRow of visibleRows(); track $index; let header = $first) {
    <tr>
      @for (item of curRow; track $index) {
        <td
          class="sd-table-cell sd-table-cell--bg-transparent"
          [attr.rowspan]="item.cell.rowspan"
          [attr.colspan]="item.cell.colspan"
          [attr.aria-sort]="header && sorter().canSort(item.start) ? (sorter().sortedColumnIndex === item.start ? (sorter().ascending ? 'ascending' : 'descending') : 'none') : null">
          <span [innerHTML]="item.cell.content"></span>
          @if (header && (item.cell.colspan ?? 1) === 1 && sorter().canSort(item.start)) {
            <wct-sort-arrows
              role="button"
              tabindex="0"
              [sortedColumnIndex]="sorter().sortedColumnIndex"
              [ascending]="sorter().ascending"
              [columnIndex]="item.start"
              (click)="sort(item.start)"
              (keydown.enter)="sort(item.start)"/>
          }
        </td>
      }
    </tr>
  }
</table>
}
